module.exports = __webpack_public_path__ + "static/media/ic_selectArrowDownOrange.dd4012e7.svg";